/**
@format
@flow
*/
import * as React from 'react';
import { Jumbo as KrispyJumbo } from '@krispy/typography/web';
import Colors from '@ziynx/theme/colors';

type Props = $ReadOnly<{|
  /**
   * Extra large font size
   */
  extraLarge?: boolean,

  /**
   * Large font size
   */
  large?: boolean,

  /**
   * Medium font size
   */
  medium?: boolean,

  /**
   * Small font size
   */
  small?: boolean,

  /**
   * Color for body text
   */
  color?: string,

  /**
   * Primitive types
   */
  primitive?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',

  /**
   * Text
   */
  children: any,
|}>;

/**
 * Jumbo component
 */
const Jumbo = (props: Props): React$Node => {
  const { color, children, ...rest } = props;

  return (
    <KrispyJumbo color={color} {...rest}>
      {children}
    </KrispyJumbo>
  );
};

Jumbo.defaultProps = {
  color: Colors.GrayVeryDark,
  primitive: 'p',
};

export default Jumbo;
